module.exports = __webpack_public_path__ + "img/mm_b1_img2.9042c726.png";